const namedOptions = [
  ["all_time", "All Time"],
  ["today", "Today"],
  ["7_days", "Last 7 Days"],
  ["14_days", "Last 14 Days"],
  ["30_days", "Last 30 Days"],
  ["90_days", "Last 90 Days"],
  ["next_month", "Next Month"],
  ["this_month", "This Month"],
  ["last_month", "Last Month"],
  ["this_quarter", "This Quarter"],
  ["last_quarter", "Last Quarter"],
  ["this_year", "This Year"],
  ["last_year", "Last Year"],
  ["custom", "Custom"],
];

const closeDateOptionsBuilder = ([value, name]) => ({
  value,
  id: value,
  name,
  title: name,
});

const baseOptions = namedOptions.map(closeDateOptionsBuilder);

export const closeDateOptions = baseOptions;
export const statusDateOptions = [...baseOptions.filter((option) => option.id !== "next_month")];
export const mutualAcceptanceDateOptions = statusDateOptions;
